<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IXYi2F/tc-custom/Cover.jpg?1650531188532?1684306039822" alt="This image is the cover for the book The Many Deaths of Laila Starr #1, The Many Deaths of Laila Starr"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Many Deaths of Laila Starr #1, The Many Deaths of Laila Starr
      </h1>
      <p class="bookDescription body article font2">
        <p>A powerful new series for fans of The Wicked + The Divine  and The Dreaming from Ram V (Justice League Dark) and Filipe Andrade (Captain Marvel) that explores the fine line between living and dying in Mumbai through the lens of magical realism. * With humanity on the verge of discovering immortality, the avatar of Death is fired and relegated to the world below to live out her now-finite days in the body of twenty-something Laila Starr in Mumbai. * Struggling with her new-found mortality, Laila has found a way to be placed in the time and place where the creator of immortality will be born... * But will Laila take her chance to permanently reverse the course of (future) history...or does a more shocking fate await her?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        V. Ram, Filipe Andrade
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?664d6640